

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
export class TransmissionService {
  static async getTransmissionLogs(filters, limitCount = 100) {
    try {
      // Build query parameters
      const params = new URLSearchParams();
      if (filters.startDate) {
        params.append('startDate', filters.startDate.toISOString());
      }
      if (filters.endDate) {
        params.append('endDate', filters.endDate.toISOString());
      }
      if (filters.direction) {
        params.append('direction', filters.direction);
      }
      if (filters.partnerType) {
        params.append('partnerType', filters.partnerType);
      }
      if (filters.partnerName) {
        params.append('partnerName', filters.partnerName);
      }
      if (filters.status) {
        params.append('status', filters.status);
      }
      if (filters.patientId) {
        params.append('patientId', filters.patientId);
      }
      if (filters.orderId) {
        params.append('orderId', filters.orderId);
      }
      if (limitCount) {
        params.append('limit', limitCount.toString());
      }

      // Get authorization token
      const token = await getAuthToken();

      const response = await fetch(`${API_BASE}/internal/transmission-logs?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const logsData = await response.json();
      
      // Transform dates back to Date objects for consistency with frontend expectations
      return logsData.map(log => ({
        ...log,
        timestamp: log.timestamp ? new Date(log.timestamp) : new Date(),
        created_at: log.created_at ? new Date(log.created_at) : new Date(),
        updated_at: log.updated_at ? new Date(log.updated_at) : new Date(),
        last_retry: log.last_retry ? new Date(log.last_retry) : null,
      }));
    } catch (error) {
      console.error('Error fetching transmission logs:', error);
      throw error;
    }
  }

  static async getTransmissionStats() {
    try {
      // Get authorization token
      const token = await getAuthToken();

      const response = await fetch(`${API_BASE}/internal/transmission-stats`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const statsData = await response.json();
      return statsData;
    } catch (error) {
      console.error('Error fetching transmission stats:', error);
      throw error;
    }
  }

  static async getTransmissionLogById(logId) {
    try {
      // Get authorization token
      const token = await getAuthToken();

      const response = await fetch(`${API_BASE}/internal/transmission-logs/${logId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const logData = await response.json();
      
      // Transform dates back to Date objects
      return {
        ...logData,
        timestamp: logData.timestamp ? new Date(logData.timestamp) : new Date(),
        created_at: logData.created_at ? new Date(logData.created_at) : new Date(),
        updated_at: logData.updated_at ? new Date(logData.updated_at) : new Date(),
        last_retry: logData.last_retry ? new Date(logData.last_retry) : null,
      };
    } catch (error) {
      console.error('Error fetching transmission log by ID:', error);
      throw error;
    }
  }

  static async searchTransmissionLogs(searchTerm, filters = {}) {
    try {
      // Build query parameters
      const params = new URLSearchParams();
      params.append('search', searchTerm);
      
      if (filters.startDate) {
        params.append('startDate', filters.startDate.toISOString());
      }
      if (filters.endDate) {
        params.append('endDate', filters.endDate.toISOString());
      }
      if (filters.direction) {
        params.append('direction', filters.direction);
      }
      if (filters.partnerType) {
        params.append('partnerType', filters.partnerType);
      }
      if (filters.status) {
        params.append('status', filters.status);
      }
      if (filters.limit) {
        params.append('limit', filters.limit.toString());
      }

      // Get authorization token
      const token = await getAuthToken();

      const response = await fetch(`${API_BASE}/internal/transmission-logs/search?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const logsData = await response.json();
      
      // Transform dates back to Date objects
      return logsData.map(log => ({
        ...log,
        timestamp: log.timestamp ? new Date(log.timestamp) : new Date(),
        created_at: log.timestamp ? new Date(log.created_at) : new Date(),
        updated_at: log.updated_at ? new Date(log.updated_at) : new Date(),
        last_retry: log.last_retry ? new Date(log.last_retry) : null,
      }));
    } catch (error) {
      console.error('Error searching transmission logs:', error);
      throw error;
    }
  }
}
